import ConnectionVerified from './ConnectionVerified'
import FacebookSettings from './FacebookSettings'
import GoogleAdwordsSettings from './GoogleAdwordsSettings'
import GoogleAnalyticsSettings from './GoogleAnalyticsSettings'
import SelectAccounts from './SelectAccounts'
import Settings from './Settings'
import SignIn from './SignIn'
import StepWithConnectionAndAccounts from './StepWithConnectionAndAccounts'

const SetupSteps = {
  ConnectionVerified,
  FacebookSettings,
  GoogleAdwordsSettings,
  GoogleAnalyticsSettings,
  SelectAccounts,
  Settings,
  SignIn,
  StepWithConnectionAndAccounts,
}

export default SetupSteps
